import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase } from '@digibricks/domains';
export var COMPLETE_PRACTICE_ASSIGNMENT_USE_CASE = 'COMPLETE_PRACTICE_ASSIGNMENT_USE_CASE';
export var CompletePraticeAssignmentUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(CompletePraticeAssignmentUseCase, _UseCase);

  var _super = _createSuper(CompletePraticeAssignmentUseCase);

  function CompletePraticeAssignmentUseCase(practiceAssignmentRepository) {
    var _this;

    _classCallCheck(this, CompletePraticeAssignmentUseCase);

    _this = _super.call(this);
    _this.practiceAssignmentRepository = practiceAssignmentRepository;
    return _this;
  }

  _createClass(CompletePraticeAssignmentUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(input) {
        var endTime, assignment, resultOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                endTime = input.endTime, assignment = input.assignment;
                assignment.complete(endTime);
                _context.next = 4;
                return this.practiceAssignmentRepository.complete(assignment);

              case 4:
                resultOrError = _context.sent;

                if (!resultOrError.isFailure) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", Result.fail(resultOrError.error));

              case 7:
                return _context.abrupt("return", Result.ok(assignment));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return CompletePraticeAssignmentUseCase;
}(UseCase);